export default __webpack_public_path__ + "671df4d9b17c6145bd846e2f180617ab.png";